// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"5452e52e","302":"a2b699d0","615":"1797ff55","766":"b45bcea4","892":"d6715d1a"}[chunkId] + ".chunk.js";
};